import { render, staticRenderFns } from "./travelzun_derecha.vue?vue&type=template&id=35cd4436&"
import script from "./travelzun_derecha.vue?vue&type=script&lang=js&"
export * from "./travelzun_derecha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports